/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Choice_Monthly_CreditInputs */

const fr_plan_choice_monthly_credit = /** @type {(inputs: Plan_Choice_Monthly_CreditInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cours par mois (Crossfit ou Hyrox)`)
};

/**

* @param {Plan_Choice_Monthly_CreditInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_monthly_credit = /** @type {((inputs: Plan_Choice_Monthly_CreditInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Monthly_CreditInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_monthly_credit(inputs)
});